// Auto-generated by scripts/version-bump.js. Do not edit by hand.
export const BUILD_INFO = Object.freeze({
  "major": 1,
  "minor": 32,
  "build": "2611040033",
  "version": "1.32.2611040033",
  "builtAt": "2026-11-04T00:33:53.152Z"
});
